import React from 'react';
import '../mainLayour.css';
import UserInfoHeader from "./avatar";
import {Menu} from "lucide-react";
import LanguageMenu from "./LanguageSelect";
import { VERDICTIA_WORDMARK_LIGHT_SRC } from "../../../brand/verdictiaBrand";
import { usePageTransition } from "../../../utils/pageTransition";

function Header({onToggleSidebar, isCollapsed = false, isMobileShell = false, isMobileSidebarOpen = false}) {
    const { navigateWithFade } = usePageTransition();
    const menuExpanded = isMobileShell ? isMobileSidebarOpen : !isCollapsed;
    const menuLabel = isMobileShell
        ? (isMobileSidebarOpen ? "Fermer le menu" : "Ouvrir le menu")
        : (isCollapsed ? "Deployer le menu" : "Reduire le menu");

    return (
        <header className="text-white header-component">
            <div className="header-left">
                <button
                    type="button"
                    className="toggle-sidebar-btn"
                    aria-label={menuLabel}
                    aria-controls="app-sidebar"
                    aria-expanded={menuExpanded}
                    onClick={onToggleSidebar}
                >
                    <Menu size={20} color="white"/>
                </button>
                <button
                    type="button"
                    className="app-header-brand"
                    aria-label="Accueil Verdictia"
                    onClick={() => navigateWithFade("/workspace")}
                >
                    <img
                        className="app-header-wordmark"
                        src={VERDICTIA_WORDMARK_LIGHT_SRC}
                        alt="Verdictia"
                        width="90"
                        height="30"
                    />
                    <span className="app-header-mobile-wordmark" aria-hidden="true">Verdictia</span>
                </button>
            </div>

            <div className="header-right">
                {/* Sélecteur de langue placé avant le profil utilisateur */}
                <LanguageMenu size="small"/>
                <UserInfoHeader fullName={"Abdesselam Belkhiri"} clientName={"Verdictia"}/>
            </div>
        </header>
    );
}

export default Header;
